module.exports = __webpack_public_path__ + "static/img/ECS.e84c409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ECS.jpg
// module id = FGDL
// module chunks = 51